import type { RegistryEntry, UiOption } from '../types';

const outputFormatOption: UiOption = {
  key: 'output_format',
  label: 'audio.output_format',
  type: 'select',
  options: [
    { label: 'MP3', value: 'mp3' },
    { label: 'WAV', value: 'wav' },
    { label: 'FLAC', value: 'flac' },
  ],
  default: 'mp3',
  group: 'basic',
};

const toOutputFormatProviderOptions: RegistryEntry['toProviderOptions'] = (ui) => ({
  output_format: typeof ui.output_format === 'string' ? ui.output_format : 'mp3',
});

export const murekaConfigs: Record<string, RegistryEntry> = {
  'mureka-v9.5-prompt-to-song': {
    options: [
      {
        key: 'styles',
        label: 'audio.styles',
        type: 'select',
        options: [
          { label: 'None', value: '' },
          { label: 'Pop', value: 'pop' },
          { label: 'Rock', value: 'rock' },
          { label: 'Jazz', value: 'jazz' },
          { label: 'R&B', value: 'r&b' },
          { label: 'EDM', value: 'edm' },
          { label: 'Ambient', value: 'ambient' },
          { label: 'Folk', value: 'folk' },
          { label: 'Latin', value: 'latin' },
          { label: 'K-Pop', value: 'k-pop' },
          { label: 'J-Pop', value: 'j-pop' },
          { label: 'House', value: 'house' },
          { label: 'Gospel', value: 'gospel' },
          { label: 'Lo-fi', value: 'lo-fi' },
        ],
        default: '',
        group: 'basic',
      },
      outputFormatOption,
    ],
    toProviderOptions: (ui) => ({
      styles: typeof ui.styles === 'string' && ui.styles ? [ui.styles] : undefined,
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'mp3',
    }),
  },
  'mureka-v9.5-generate-song': {
    options: [outputFormatOption],
    toProviderOptions: toOutputFormatProviderOptions,
  },
  'mureka-v9.5-generate-bgm': {
    options: [outputFormatOption],
    toProviderOptions: toOutputFormatProviderOptions,
  },
};